var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQrCodeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QrCode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6196 5H7.61963C6.51506 5 5.61963 5.89543 5.61963 7V13C5.61963 14.1046 6.51506 15 7.61963 15H13.6196C14.7242 15 15.6196 14.1046 15.6196 13V7C15.6196 5.89543 14.7242 5 13.6196 5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6196 17H7.61963C6.51506 17 5.61963 17.8954 5.61963 19V25C5.61963 26.1046 6.51506 27 7.61963 27H13.6196C14.7242 27 15.6196 26.1046 15.6196 25V19C15.6196 17.8954 14.7242 17 13.6196 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.6196 5H19.6196C18.5151 5 17.6196 5.89543 17.6196 7V13C17.6196 14.1046 18.5151 15 19.6196 15H25.6196C26.7242 15 27.6196 14.1046 27.6196 13V7C27.6196 5.89543 26.7242 5 25.6196 5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6196 23C18.8848 23 19.1392 22.8946 19.3267 22.7071C19.5143 22.5196 19.6196 22.2652 19.6196 22V18C19.6196 17.7348 19.5143 17.4804 19.3267 17.2929C19.1392 17.1054 18.8848 17 18.6196 17C18.3544 17 18.1001 17.1054 17.9125 17.2929C17.725 17.4804 17.6196 17.7348 17.6196 18V22C17.6196 22.2652 17.725 22.5196 17.9125 22.7071C18.1001 22.8946 18.3544 23 18.6196 23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.6196 19H23.6196V18C23.6196 17.7348 23.5143 17.4804 23.3267 17.2929C23.1392 17.1054 22.8848 17 22.6196 17C22.3544 17 22.1001 17.1054 21.9125 17.2929C21.725 17.4804 21.6196 17.7348 21.6196 18V25H18.6196C18.3544 25 18.1001 25.1054 17.9125 25.2929C17.725 25.4804 17.6196 25.7348 17.6196 26C17.6196 26.2652 17.725 26.5196 17.9125 26.7071C18.1001 26.8946 18.3544 27 18.6196 27H22.6196C22.8848 27 23.1392 26.8946 23.3267 26.7071C23.5143 26.5196 23.6196 26.2652 23.6196 26V21H26.6196C26.8848 21 27.1392 20.8946 27.3267 20.7071C27.5143 20.5196 27.6196 20.2652 27.6196 20C27.6196 19.7348 27.5143 19.4804 27.3267 19.2929C27.1392 19.1054 26.8848 19 26.6196 19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.6196 23C26.3544 23 26.1001 23.1054 25.9125 23.2929C25.725 23.4804 25.6196 23.7348 25.6196 24V26C25.6196 26.2652 25.725 26.5196 25.9125 26.7071C26.1001 26.8946 26.3544 27 26.6196 27C26.8848 27 27.1392 26.8946 27.3267 26.7071C27.5143 26.5196 27.6196 26.2652 27.6196 26V24C27.6196 23.7348 27.5143 23.4804 27.3267 23.2929C27.1392 23.1054 26.8848 23 26.6196 23Z",
    fill: "black"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQrCodeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QrCodeIcon.85609f13.svg";
export { ForwardRef as ReactComponent };